module.exports = __webpack_public_path__ + "static/media/Case-Stadies-single.07388b73.jpg";